import React from "react";

import { getTagFromResource, partitionBy } from "@examspark/common";
import { Text, Toolbar, VSpace } from "@examspark/common-ui";
import { ParsedTCMPCUnit } from "@examspark/types";

import TEKSGrid from "./TEKSGrid";

type Props = {
  unit: ParsedTCMPCUnit | undefined;
};

const UnitTeks = ({ unit }: Props) => {
  const objectives = unit?.objectives;

  const groupedObjectives = partitionBy(objectives ?? [], (o) => {
    const tag = getTagFromResource(o, "tcmpc-teks-curriculum-usage")?.value;
    console.log("tag", tag);
    return tag;
  });

  if (!unit?.objectives?.length) {
    return null;
  }

  return (
    <>
      <VSpace>
        <Toolbar>
          <Text.H3>TEKS Taught in This Unit / Module</Text.H3>
        </Toolbar>
        {objectives?.length === 0 && (
          <div
            style={{
              border: "dashed 1px #ddd",
              padding: "2rem",
              borderRadius: "0.5rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              backgroundColor: "#f7f7f7",
            }}
          >
            <div
              style={{
                color: "#333",
                fontWeight: "500",
                fontSize: "1.4rem",
              }}
            >
              No Standards to Show
            </div>
          </div>
        )}
        <VSpace size={"2rem"}>
          {[
            { label: "Taught Directly", key: "DIRECTLY_TAUGHT" },
            { label: "Developing", key: "DEVELOPING" },
            // { label: "Ongoing", key: "ONGOING" },
          ].map((item) => {
            if (!groupedObjectives[item.key]?.length) return null;

            return (
              <TEKSGrid
                key={item.key}
                label={item.label}
                objectives={groupedObjectives[item.key] ?? []}
                unit={unit}
              />
            );
          })}
        </VSpace>
      </VSpace>
    </>
  );
};

export default UnitTeks;
